import React from 'react';
import PropTypes from 'prop-types';
import replace from "lodash/replace";
import map from "lodash/map";
import filter from "lodash/filter";
import sortBy from "lodash/sortBy";
import { BootstrapModal } from 'shared-components/modal/bootstrap-modal';
import { FormattedMessage } from 'react-intl';

export class ActivityModal extends React.Component {
  render () {
    const { activities, showModal, closeModal, onClickActivity } = this.props;
    const useTypes = filter(activities, (a) => { return replace(a.use_subtype, ' ', '-').toLowerCase() === a.id; });
    const sortedActivities = sortBy(useTypes, 'dropdown');
    return (
      <BootstrapModal
        showModal={showModal}
        modalSize="sm-size"
        modalClass="activity-modal"
        onClose={closeModal}
        header={ <h3><FormattedMessage id="search.activity_modal.popular_activities" defaultMessage="Popular Activities" /></h3> }
        body={
          <div className="container-fluid">
            <div className="row">
              <div className="col-xs-12">
                <ul style={{ listStyle: 'none', paddingLeft: 0 }}>
                  {
                    map(sortedActivities, (act) => {
                      return (
                        <div key={act.id}className="col-xs-12 col-sm-6">
                          <li>
                            <button
                              className="btn btn-link remove-click-styling"
                              onClick={(e) => { onClickActivity(e, closeModal); }}
                              data-value={act.id}
                            >
                              {act.dropdown}
                            </button>
                          </li>
                        </div>
                      );
                    })
                  }
                </ul>
              </div>
            </div>
          </div>
        }
      />
    );
  }
}

ActivityModal.propTypes = {
  activities: PropTypes.array.isRequired,
  showModal: PropTypes.bool,
  closeModal: PropTypes.func,
  onClickActivity: PropTypes.func
};
